import * as XLSX from 'xlsx-js-style';
import dayjs from 'dayjs';
import { applyWorkbookLtr, applyWorkbookRtl, buildReportSheet } from '../../../../Utils/ExcelReport';

/** The revaluation froze at the end of 2007, so form 1343 runs from tax year 2008. */
export const FORM_1343_FIRST_YEAR = 2008;

/** Mirrors Server Form1343Status. */
export const FORM_1343_STATUS = {
    Eligible: 0,
    PurchasedAfter2007: 1,
    Excluded: 2,
    NoDepreciation: 3,
    MissingCoefficient: 4,
};

export const FORM_1343_STATUS_KEYS = {
    0: 'eligible',
    1: 'purchasedAfter2007',
    2: 'excluded',
    3: 'noDepreciation',
    4: 'missingCoefficient',
};

const round2 = (value) => (value == null ? null : Math.round(Number(value) * 100) / 100);

/** The official form lists only the eligible assets. */
export const exportForm1343Excel = ({ client, report, t, direction }) => {
    const eligible = report.rows.filter((row) => row.status === FORM_1343_STATUS.Eligible);
    const header = [
        t('form1343.columns.asset'),
        t('form1343.columns.group'),
        t('form1343.columns.originalPrice'),
        t('form1343.columns.purchaseDate'),
        t('form1343.columns.depreciation'),
        t('form1343.columns.coefficient'),
        t('form1343.columns.additionalDeduction'),
    ];
    const rows = eligible.map((row) => [
        [row.assetNumber, row.name].filter(Boolean).join(' – '),
        row.assetGroupName || t('form1343.noGroup'),
        round2(row.originalPrice),
        row.purchaseDate ? dayjs(row.purchaseDate).format('DD/MM/YYYY') : '',
        round2(row.depreciationThisYear),
        row.coefficient == null ? '' : Number(row.coefficient).toFixed(4),
        round2(row.additionalDeduction),
    ]);
    rows.push([
        t('form1343.totals'), '', null, '',
        round2(report.eligibleDepreciation), '', round2(report.totalAdditionalDeduction),
    ]);

    const ws = buildReportSheet({
        titleLines: [
            `${client?.name || ''} (${client?.caseId || ''})`,
            `${t('form1343.title')} – ${report.taxYear}`,
        ],
        header,
        rows,
        colWidths: [36, 22, 16, 14, 16, 12, 18],
        numericColIndexes: [2, 4, 6],
        totalRowIndexes: [rows.length - 1],
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, String(report.taxYear));
    if (direction === 'ltr') applyWorkbookLtr(wb);
    else applyWorkbookRtl(wb);
    XLSX.writeFile(wb, `1343_${client?.caseId || ''}_${report.taxYear}.xlsx`);
};
